import { UrlHelpers } from "@/shared/services/UrlHelpers";
import { VirtualFileSystem } from "../mediaRepository/VirtualFileSystem";
import { MediaImageRepositoryProcessingOffscreen } from "@/shared/MediaImageRepositoryProcessingOffscreen";

export class ScreenshotProvider {
    static screenshotMaxEdge = 512;

    static async saveScreenshot(projectId, base64: string): Promise<boolean> {
        let offscreenProcessing = new MediaImageRepositoryProcessingOffscreen();
        let hasTransparency = await offscreenProcessing.hasTransparency(base64);
        let imageBlobString = await offscreenProcessing.base64ToBlobUrl(base64, hasTransparency);
        let thumbnail = await offscreenProcessing.resizeBase64ToMaxEdgeSize(base64, ScreenshotProvider.screenshotMaxEdge);
        let thumbnailBlobString = await offscreenProcessing.base64ToBlobUrl(thumbnail, hasTransparency);
        await VirtualFileSystem.getInstance().writeBlobUrl(this.screenshotProjectUrl(projectId, true), thumbnailBlobString)
        await VirtualFileSystem.getInstance().writeBlobUrl(this.screenshotProjectUrl(projectId, false), imageBlobString)
        
        return true;
    }

    static screenshotFilename(): string {
        const screenshotName = "screenshot_thumbnail.jpg"
        return screenshotName
    }

    static highResFilename(): string {
        const screenshotName = "screenshot_hires.jpg"
        return screenshotName
    }

    static screenshotRelativeToProject(projectId: String, isThumbnail: boolean = true): string {
        let fileName = isThumbnail ? this.screenshotFilename() : this.highResFilename()
        return `/${projectId}/${fileName}`
    }

    static screenshotProjectUrl(projectId: String, isThumbnail: boolean = true): string  {
        return `/projects${this.screenshotRelativeToProject(projectId, isThumbnail)}`
    }
}